module.exports = __webpack_public_path__ + "img/23.5f056f16.png";